import { z } from "zod";

export const verifyPasswordResponseSchema = z.object({
  isVerify: z.enum(["Y", "N"]),
});

export type VerifyPasswordResponseType = z.infer<typeof verifyPasswordResponseSchema>;
